import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatExpansionModule } from '@angular/material/expansion';
import { FoldMenuComponent } from './fold-menu/fold-menu.component';
import { NavigationComponent } from './navigation.component';
import { CoreModule } from '../core/core.module';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { navigationReducer } from './state/navigation.reducers';
import { featureKey } from './state/navigation.state';
import { NavigationEffects } from './state/navigation.effects';
import { NavigationService } from './navigation.service';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    declarations: [FoldMenuComponent, NavigationComponent, NavMenuComponent],
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        MatExpansionModule,
        CoreModule,
        StoreModule.forFeature(featureKey, navigationReducer),
        EffectsModule.forFeature([NavigationEffects]),
        SharedModule
    ],
    providers: [NavigationService],
    exports: [NavigationComponent]
})
export class NavigationModule {}
